import { useState, useEffect } from "react";

/**
 * Generic debounce hook
 * @param {*} value - The value you want to debounce
 * @param {number} delay - Delay in ms (default 500)
 * @returns debounced value
 */
export function useDebounce(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler); // cleanup
  }, [value, delay]);

  return debouncedValue;
}
